import React from 'react';
import { TartaWordmark } from './TartaWordmark';
import { CircleLight } from './CircleLight';
type Props = {
  size?: number;
  variant?: 'dark' | 'light';
  withTagline?: boolean;
  /** Renders the subtle light that travels around the lid's rim. */
  circleLight?: boolean;
  className?: string;
};
export function TartaEmblem({
  size = 120,
  variant = 'dark',
  withTagline = true,
  circleLight = false,
  className = ''
}: Props) {
  const isDark = variant === 'dark';
  const bg = isDark ? 'bg-chocolate' : 'bg-cream';
  const fg = isDark ? 'text-cream' : 'text-chocolate';
  return <div className={`${bg} ${fg} relative rounded-full flex flex-col items-center justify-center ${className}`} style={{
    width: size,
    height: size
  }} aria-label="TARTA — A slice of heaven" data-id="element-357" data-mp="f4579ax056am">
      {circleLight && <CircleLight speed="slow" data-id="element-358" data-mp="1qhz84kn9075r" />}
      <TartaWordmark height={size * 0.16} strokeWidth={1.5} data-id="element-359" data-mp="1mhyuv3bvy20a" />
      {withTagline && <span className="mt-[0.6em] tracking-[0.05em] opacity-90 font-sans font-light" style={{
      fontSize: size * 0.058
    }} data-id="element-360" data-mp="1mkb8x5eivs82">
          A slice of heaven
        </span>}
    </div>;
}